import * as React from 'react';
var SizeContext = /*#__PURE__*/React.createContext(undefined);
SizeContext.displayName = 'SizeContext';
export var SizeConsumer = SizeContext.Consumer;
export var SizeProvider = SizeContext.Provider;
export default SizeContext;